import { ComponentSlotStyle, Text } from "@fluentui/react-northstar";
import React from "react";

export interface RegularTextProps {
    content?: string;
    className?: string;
    weight?: "light" | "semilight" | "regular" | "semibold" | "bold";
    isLabel?: boolean;
    smaller?: boolean;
}

export const RegularText: React.FC<RegularTextProps> = (props) => {
    return (
        <Text
            size={props.smaller ? "small" : "medium"}
            styles={
                props.isLabel
                    ? ({ theme: { siteVariables } }) => ({
                          color: siteVariables.colorScheme.default.foreground5,
                      })
                    : undefined
            }
            weight={props.weight}
            className={props.className}
        >
            {props.content}
        </Text>
    );
};
